<template>
  <div class="dabie-container">
    <div id="cesiumContainer"></div>
    <div class="ui-toggle-btn" @click="uiVisible = !uiVisible" :title="uiVisible ? '隐藏界面' : '显示界面'">{{ uiVisible ? "⬛" : "⬜" }}</div>
    <div class="overlay-controls" v-show="uiVisible">
      <div class="ctrl-panel" :class="{ collapsed: panelCollapsed }">
        <div class="panel-toggle" @click="panelCollapsed = !panelCollapsed">{{ panelCollapsed ? "▶" : "◀" }}</div>
        <div class="ctrl-title" v-show="!panelCollapsed">🏔️ 大别山</div>
        <div v-show="!panelCollapsed">
        <label class="toggle-row">
          <input type="checkbox" v-model="showBoundary" @change="toggleBoundary" />
          <span>边界范围</span>
        </label>
        <div class="toggle-group">
        <label class="toggle-row">
          <input type="checkbox" v-model="showRivers" @change="toggleRivers" />
          <span>河流水系</span>
        </label>
        <div class="sub-toggles" v-show="showRivers">
          <label class="toggle-row sub-row">
            <input type="checkbox" v-model="showRiverMain" @change="onRiverSubChange" />
            <span class="sub-swatch" style="background:#1976D2"></span>
            <span>河流</span>
          </label>
          <label class="toggle-row sub-row">
            <input type="checkbox" v-model="showRiverCanal" @change="onRiverSubChange" />
            <span class="sub-swatch" style="background:#42A5F5"></span>
            <span>运河</span>
          </label>
          <label class="toggle-row sub-row">
            <input type="checkbox" v-model="showRiverStream" @change="onRiverSubChange" />
            <span class="sub-swatch" style="background:#90CAF9"></span>
            <span>溪流</span>
          </label>
          <label class="toggle-row sub-row">
            <input type="checkbox" v-model="showRiverDrain" @change="onRiverSubChange" />
            <span class="sub-swatch" style="background:#BBDEFB"></span>
            <span>排水渠</span>
          </label>
        </div>
      </div>
        <label class="toggle-row">
          <input type="checkbox" v-model="showWater" @change="toggleWater" />
          <span>湖泊水库</span>
        </label>
        <label class="toggle-row">
          <input type="checkbox" v-model="showLandcover" @change="toggleLandcover" />
          <span>土地利用</span>
        </label>
        <label class="toggle-row">
          <input type="checkbox" v-model="showWeather" @change="toggleWeather" />
          <span>天气状况</span>
        </label>
        <button class="reset-btn" @click="flyHome">📍 复位</button>
        </div>
      </div>
    </div>
    <div class="overview-wrap" v-show="uiVisible" :class="{ collapsed: overviewCollapsed }">
      <div class="overview-toggle" @click="overviewCollapsed = !overviewCollapsed">{{ overviewCollapsed ? "◀" : "▶" }}</div>
      <div class="overview-map">
        <iframe src="/projects/dabieshan/overview.html" class="overview-iframe"></iframe>
        <div class="overview-label">📍 鹰眼</div>
      </div>
    </div>
        <div class="weather-panel" v-show="uiVisible && showWeather">
      <div class="weather-title">🌤️ 周边天气</div>
      <div class="weather-loading" v-if="weatherLoading">加载中...</div>
      <div class="weather-cities" v-else>
        <div class="weather-row" v-for="w in weatherData" :key="w.city">
          <span class="w-city">{{ w.city }}</span>
          <span class="w-temp">{{ w.temp }}°</span>
          <span class="w-icon">{{ w.icon }}</span>
          <span class="w-desc">{{ w.weather }}</span><span class="w-humid">💧{{ w.humid }}%</span><span class="w-wind">{{ w.wind }}</span>
        </div>
      </div>
      <div class="weather-update" v-if="weatherData.length">更新于 {{ updateTime }}</div>
    </div>
    <div class="dem3d-overlay" v-show="uiVisible"><iframe src="/projects/dabieshan/dem3d_v2.html" class="dem3d-iframe"></iframe><div class="dem3d-label">🗻 3D DEM</div></div>
  
    <div class="legend-panel" v-show="uiVisible && showLandcover && legendClasses.length">
      <div class="legend-title">土地覆盖图例</div>
      <div class="legend-list">
        <div class="legend-item" v-for="c in legendClasses" :key="c.id">
          <span class="legend-swatch" :style="{ background: c.color }"></span>
          <span class="legend-name">{{ c.name }}</span>
        </div>
      </div>
      <div class="legend-opacity">
        <span class="opacity-label">透明度</span>
        <input type="range" min="0" max="100" :value="Math.round(landcoverAlpha * 100)" @input="onAlphaChange" />
        <span class="opacity-val">{{ Math.round(landcoverAlpha * 100) }}%</span>
      </div>
    </div>
  
</div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import * as Cesium from "cesium";
import "./Widgets/widgets.css";
Cesium.Ion.defaultAccessToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJlNGEzNjIwYS05Nzc3LTQ0ZmEtYTYwMC04Y2Y0ZmJhMmRhNWIiLCJpZCI6NDI4MjMyLCJzdWIiOiJYdW5oZVpoYW5nIiwiaXNzIjoiaHR0cHM6Ly9pb24uY2VzaXVtLmNvbSIsImF1ZCI6Ik15X2ZpcnN0X0Nlc2l1bUFQUCIsImlhdCI6MTc3ODEyNzY3MH0.pz-4Wv2sRORBqe6_WRAUqhkzOMOwX8ukiZxkHx_VNjo";
window.CESIUM_BASE_URL = "/projects/dabieshan/";

const overviewCollapsed = ref(false);
const panelCollapsed = ref(false);
const uiVisible = ref(true);
const showBoundary = ref(true);
const showRivers = ref(true);
const showWater = ref(true);
const showRiverMain = ref(true);
const showRiverCanal = ref(true);
const showRiverStream = ref(true);
const showRiverDrain = ref(false);
const showLandcover = ref(false);
const showWeather = ref(false);
const weatherData = ref([]);
const weatherLoading = ref(false);
const legendClasses = ref([]);
const landcoverAlpha = ref(0.7);
let waterDss = null;
let landcoverLayer = null;
let viewer = null;
let boundaryPrimitives = null;
let boundaryEntities = null;

async function toggleBoundary() {
  if (showBoundary.value) {
    if (!boundaryPrimitives) {
      var resp = await fetch("/projects/dabieshan/data/dabieshan_boundary.json");
      var geo = await resp.json();
      var rings = geo.features[0].geometry.coordinates;
      for (var r = 0; r < rings.length; r++) {
        var ring = rings[r];
        var positions = ring.map(function(c) { return Cesium.Cartesian3.fromDegrees(c[0], c[1]); });
        var fillPoly = viewer.entities.add({
          polygon: { hierarchy: new Cesium.PolygonHierarchy(positions), material: Cesium.Color.fromCssColorString("#FFD700").withAlpha(0.12), classificationType: Cesium.ClassificationType.TERRAIN, zIndex: 500 }
        });
        if (!boundaryEntities) boundaryEntities = [];
        boundaryEntities.push(fillPoly);
        try {
          var pline = viewer.scene.groundPrimitives.add(new Cesium.GroundPolylinePrimitive({
            geometryInstances: new Cesium.GeometryInstance({ geometry: new Cesium.GroundPolylineGeometry({ positions: positions, width: 6.0 }) }),
            appearance: new Cesium.PolylineMaterialAppearance({ material: Cesium.Material.fromType("Color", { color: Cesium.Color.fromCssColorString("#FFD700") }) }),
          }));
          if (!boundaryPrimitives) boundaryPrimitives = [];
          boundaryPrimitives.push(pline);
        } catch(e) { console.warn(e); }
      }
    } else {
      for (var i = 0; i < boundaryPrimitives.length; i++) boundaryPrimitives[i].show = true;
      for (var i = 0; i < boundaryEntities.length; i++) boundaryEntities[i].show = true;
    }
  } else {
    if (boundaryPrimitives) for (var i = 0; i < boundaryPrimitives.length; i++) boundaryPrimitives[i].show = false;
    if (boundaryEntities) for (var i = 0; i < boundaryEntities.length; i++) boundaryEntities[i].show = false;
  }
}

let riverDssList = [];
let riverGrades = null;

async function toggleRivers() {
  if (showRivers.value) {
    if (!riverDssList.length) {
      try {
        riverGrades = [
          { file: "/projects/dabieshan/data/dabieshan_rivers_river.json", baseWidth: 3, color: "#1976D2" },
          { file: "/projects/dabieshan/data/dabieshan_rivers_canal.json", baseWidth: 2, color: "#42A5F5" },
          { file: "/projects/dabieshan/data/dabieshan_rivers_stream.json", baseWidth: 1.5, color: "#90CAF9" },
          { file: "/projects/dabieshan/data/dabieshan_rivers_drain.json", baseWidth: 1, color: "#BBDEFB" },
        ];
        for (var gi = 0; gi < riverGrades.length; gi++) {
          var g = riverGrades[gi];
          var w = g.baseWidth * riverWidthScale();
          var ds = await Cesium.GeoJsonDataSource.load(g.file, {
            stroke: Cesium.Color.fromCssColorString(g.color).withAlpha(0.9),
            strokeWidth: w,
            clampToGround: true,
          });
          ds._gradeIndex = gi;
          viewer.dataSources.add(ds);
          riverDssList.push(ds);
        }
      } catch(e) { console.warn("river:", e); }
    } else {
      onRiverSubChange();
    }
  } else {
    for (var i = 0; i < riverDssList.length; i++) riverDssList[i].show = false;
  }
}

function onRiverSubChange() {
  if (!riverDssList.length) return;
  var vis = [showRiverMain.value, showRiverCanal.value, showRiverStream.value, showRiverDrain.value];
  for (var i = 0; i < riverDssList.length; i++) {
    riverDssList[i].show = vis[i] !== false;
  }
}

function riverWidthScale() {
  if (!viewer) return 1;
  var h = viewer.camera.positionCartographic ? viewer.camera.positionCartographic.height : 250000;
  if (!h && viewer.camera.position) {
    var cp = Cesium.Cartographic.fromCartesian(viewer.camera.position);
    h = cp ? cp.height : 250000;
  }
  // 高 > 500km → 0.3x, 高 ~250km → 0.6x, 高 ~50km → 1x, 高 <10km → 1.5x
  if (h > 500000) return 0.3;
  if (h > 200000) return 0.3 + 0.3 * (1 - (h - 200000) / 300000);
  if (h > 50000) return 0.6 + 0.4 * (1 - (h - 50000) / 150000);
  return 1 + 0.5 * (1 - h / 50000);
}

// 监听相机变化更新线宽
var lastRiverScale = -1;
function updateRiverWidths() {
  if (!riverDssList.length || !riverGrades) return;
  var scale = riverWidthScale();
  if (Math.abs(scale - lastRiverScale) < 0.05) return;
  lastRiverScale = scale;
  for (var i = 0; i < riverDssList.length; i++) {
    var ds = riverDssList[i];
    var g = riverGrades[ds._gradeIndex || i];
    var w = g.baseWidth * scale;
    var ents = ds.entities.values;
    for (var j = 0; j < ents.length; j++) {
      var p = ents[j].polyline;
      if (p && p.width) p.width = w;
    }
  }
}

async function toggleWater() {
  if (showWater.value) {
    if (!waterDss) {
      try {
        waterDss = await Cesium.GeoJsonDataSource.load("/projects/dabieshan/data/dabieshan_water.json", { stroke: Cesium.Color.fromCssColorString("#1E90FF"), strokeWidth: 1, fill: Cesium.Color.fromCssColorString("#1E90FF").withAlpha(0.28), clampToGround: true });
        viewer.dataSources.add(waterDss);
      } catch(e) { console.warn("water:", e); }
    } else { waterDss.show = true; }
  } else { if (waterDss) waterDss.show = false; }
}

async function toggleLandcover() {
  if (showLandcover.value) {
    if (!landcoverLayer) {
      try {
        console.log("[LC] loading meta...");
        var resp = await fetch("/projects/dabieshan/data/dabieshan_landcover_meta.json");
        var meta = await resp.json();
        console.log("[LC] meta:", meta.west, meta.south, meta.east, meta.north, meta.width + "x" + meta.height);
        var rect = Cesium.Rectangle.fromDegrees(meta.west, meta.south, meta.east, meta.north);
        console.log("[LC] rect:", rect);
        // 直接用 Image 测试能否加载
        var img = new Image();
        img.onload = function() { console.log("[LC] image loaded:", img.width, "x", img.height); };
        img.onerror = function(e) { console.warn("[LC] image load error:", e); };
        img.src = meta.url;
        var provider = new Cesium.SingleTileImageryProvider({ url: meta.url, rectangle: rect, tileWidth: meta.width, tileHeight: meta.height });
        console.log("[LC] provider ready:", provider.ready);
        var ready = await provider.readyPromise;
        console.log("[LC] provider readyPromise resolved");
        landcoverLayer = viewer.imageryLayers.addImageryProvider(provider);
        landcoverLayer.alpha = 0.7;
        console.log("[LC] layer added");
        legendClasses.value = meta.classes || [];
        landcoverLayer.alpha = landcoverAlpha.value;
      } catch(e) {
        console.warn("landcover:", e);
        showLandcover.value = false;
      }
    } else {
      landcoverLayer.show = true;
    }
  } else {
    if (landcoverLayer) landcoverLayer.show = false;
  }
}

function onAlphaChange(e) {
  landcoverAlpha.value = parseInt(e.target.value) / 100;
  if (landcoverLayer) landcoverLayer.alpha = landcoverAlpha.value;
}

let updateTime = "";

async function toggleWeather() {
  if (showWeather.value) {
    weatherLoading.value = true;
    if (!window._amapReady) {
      var wait = 0;
      while (!window._amapReady && wait < 100) { await new Promise(function(r) { setTimeout(r, 200); }); wait++; }
    }
    if (window._amapReady) {
      await fetchWeather();
    } else {
      weatherData.value = [{ city:"加载失败", temp:"-", weather:"请检查网络", icon:"❌", humid:"-", wind:"-" }];
    }
    weatherLoading.value = false;
  }
}


// 视窗周边城市及adcode
var nearbyCities = [
  { name:"桐柏县", adcode:"411330", lon:113.41, lat:32.37 },
  { name:"信阳市", adcode:"411500", lon:114.09, lat:32.13 },
  { name:"罗山县", adcode:"411521", lon:114.53, lat:32.20 },
  { name:"光山县", adcode:"411522", lon:114.92, lat:32.01 },
  { name:"新县", adcode:"411523", lon:114.88, lat:31.64 },
  { name:"商城县", adcode:"411524", lon:115.41, lat:31.80 },
  { name:"固始县", adcode:"411525", lon:115.68, lat:32.18 },
  { name:"潢川县", adcode:"411526", lon:115.05, lat:32.13 },
  { name:"息县", adcode:"411528", lon:114.74, lat:32.34 },
  { name:"红安县", adcode:"421122", lon:114.62, lat:31.29 },
  { name:"罗田县", adcode:"421123", lon:115.40, lat:30.79 },
  { name:"英山县", adcode:"421124", lon:115.68, lat:30.74 },
  { name:"麻城市", adcode:"421181", lon:115.02, lat:31.18 },
  { name:"武穴市", adcode:"421182", lon:115.56, lat:29.85 },
  { name:"黄梅县", adcode:"421127", lon:115.94, lat:30.07 },
  { name:"金寨县", adcode:"341524", lon:115.93, lat:31.73 },
  { name:"霍山县", adcode:"341525", lon:116.33, lat:31.41 },
  { name:"舒城县", adcode:"341523", lon:116.95, lat:31.46 },
  { name:"岳西县", adcode:"340828", lon:116.36, lat:30.85 },
  { name:"潜山市", adcode:"340882", lon:116.58, lat:30.63 },
  { name:"太湖县", adcode:"340825", lon:116.31, lat:30.45 },
  { name:"宿松县", adcode:"340826", lon:116.13, lat:30.15 },
  { name:"大悟县", adcode:"420922", lon:114.13, lat:31.56 },
  { name:"蕲春县", adcode:"421126", lon:115.44, lat:30.24 },
  { name:"黄陂区", adcode:"420116", lon:114.38, lat:30.88 },
  { name:"武汉市", adcode:"420100", lon:114.30, lat:30.60 },
  { name:"合肥市", adcode:"340100", lon:117.23, lat:31.82 },
  { name:"六安市", adcode:"341500", lon:116.50, lat:31.73 },
  { name:"安庆市", adcode:"340800", lon:117.05, lat:30.53 },
  { name:"黄冈市", adcode:"421100", lon:114.88, lat:30.45 },
  { name:"九江市", adcode:"360400", lon:116.00, lat:29.70 },
];

function getVisibleCities() {
  if (!viewer) return nearbyCities.slice(0, 7);
  var cp = Cesium.Cartographic.fromCartesian(viewer.camera.position);
  var camLon = Cesium.Math.toDegrees(cp.longitude);
  var camLat = Cesium.Math.toDegrees(cp.latitude);
  // 按距离排序，取最近的7个
  var sorted = nearbyCities.map(function(c) {
    var d = Math.sqrt((c.lon-camLon)**2 + (c.lat-camLat)**2);
    return { c:c, d:d };
  }).sort(function(a,b) { return a.d - b.d; });
  return sorted.slice(0, 3).map(function(x) { return x.c; });
}

function queryCityWeather(adcode) {
  return new Promise(function(resolve, reject) {
    AMap.plugin("AMap.Weather", function() {
      var weather = new AMap.Weather();
      weather.getLive(adcode, function(err, data) {
        if (err) { reject(err); return; }
        resolve(data);
      });
    });
  });
}

async function fetchWeather() {
  var cities = getVisibleCities();
  if (!window._amapReady) return;
  var results = [];
  var icons = { "晴":"☀️","多云":"⛅","阴":"☁️","阵雨":"🌦️","雷阵雨":"⛈️","小雨":"🌧️","中雨":"🌧️","大雨":"🌧️","雪":"❄️","雾":"🌫️","霾":"😷" };
  for (var ci = 0; ci < cities.length; ci++) {
    var c = cities[ci];
    try {
      var data = await queryCityWeather(c.adcode);
      if (data) {
        var w = data.weather || "";
        var icon = "🌡️";
        for (var kw in icons) { if (w.indexOf(kw) !== -1) { icon = icons[kw]; break; } }
        results.push({
          city: c.name, temp: data.temperature, weather: w, icon: icon,
          humid: data.humidity, wind: (data.windDirection || "") + "风 " + (data.windPower || "") + "级"
        });
      }
    } catch(e) { console.warn("weather:", c.name, e); }
  }
  weatherData.value = results;
  var now = new Date();
  updateTime = now.getHours().toString().padStart(2,"0") + ":" + now.getMinutes().toString().padStart(2,"0");
}

function flyHome() {
  viewer.camera.flyTo({
    destination: Cesium.Cartesian3.fromDegrees(115.8, 31.0, 250000),
    orientation: { heading: Cesium.Math.toRadians(0), pitch: Cesium.Math.toRadians(-90), roll: 0 },
    duration: 2,
  });
}

let overviewFrame = null;
function initOverview() {
  overviewFrame = document.querySelector(".overview-iframe");
  if (!overviewFrame) return;
  fetch("/projects/dabieshan/data/dabieshan_boundary.json").then(r=>r.json()).then(geo => {
    var coords = geo.features[0].geometry.coordinates[0];
    var lngs = coords.map(c=>c[0]), lats = coords.map(c=>c[1]);
    overviewFrame.contentWindow.postMessage({ type: "boundary", geo }, "*");
    overviewFrame.contentWindow.postMessage({ type: "bbox", bbox: { minLng: Math.min(...lngs), maxLng: Math.max(...lngs), minLat: Math.min(...lats), maxLat: Math.max(...lats) } }, "*");
  });
  viewer.camera.changed.addEventListener(function() {
    var cp = Cesium.Cartographic.fromCartesian(viewer.camera.position);
    if (cp && overviewFrame) {
      overviewFrame.contentWindow.postMessage({ type: "position", lon: Cesium.Math.toDegrees(cp.longitude), lat: Cesium.Math.toDegrees(cp.latitude) }, "*");
    }
  });
}

onMounted(async () => {
  // 初始化高德 JS API（安全密钥必须顶层设置）
  window._AMapSecurityConfig = { securityJsCode: "2289c078497a71b28f314e4bda4fd462" };
  window._amapReady = false;
  var amapScript = document.createElement("script");
  amapScript.src = "https://webapi.amap.com/maps?v=2.0&key=8c8108669f737729f473fb63c9e2a2c0&plugin=AMap.Weather";
  amapScript.onload = function() { setTimeout(function() { window._amapReady = true; }, 500); };
  amapScript.onerror = function() { console.warn("AMap load fail"); };
  document.head.appendChild(amapScript);

  viewer = new Cesium.Viewer("cesiumContainer", {
    infoBox: false, geocoder: false, homeButton: false,
    sceneModePicker: false, baseLayerPicker: false,
    navigationHelpButton: false, animation: false, timeline: false,
    fullscreenButton: false,
  });
  try {
    viewer.terrainProvider = await Cesium.CesiumTerrainProvider.fromIonAssetId(1, { requestVertexNormals: true, requestWaterMask: false });
    viewer.scene.globe.depthTestAgainstTerrain = true;
  } catch(e) {
    viewer.terrainProvider = new Cesium.EllipsoidTerrainProvider();
  }
  if (viewer.scene.verticalExaggeration !== undefined) {
    viewer.scene.verticalExaggeration = 1.8;
    viewer.scene.verticalExaggerationRelativeHeight = 0;
  }
  viewer.imageryLayers.addImageryProvider(new Cesium.UrlTemplateImageryProvider({ url: "https://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TileCol={x}&TileRow={y}&TileMatrix={z}&tk=a05534286b98e9ff6fbb40d77e97066e", maximumLevel: 18 }));
  viewer.imageryLayers.addImageryProvider(new Cesium.UrlTemplateImageryProvider({ url: "https://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TileCol={x}&TileRow={y}&TileMatrix={z}&tk=a05534286b98e9ff6fbb40d77e97066e", maximumLevel: 18 }));
  viewer.cesiumWidget.creditContainer.style.display = "none";
  await toggleBoundary();
  toggleRivers();
  toggleWater();
  initOverview();
  var weatherTimer = null;
  viewer.camera.changed.addEventListener(function() {
    updateRiverWidths();
    if (showWeather.value) {
      clearTimeout(weatherTimer);
      weatherTimer = setTimeout(function() { fetchWeather(); }, 2000);
    }
  });
  flyHome();
});
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
html, body, #app { width: 100%; height: 100%; overflow: hidden; }
.dabie-container { width: 100vw; height: 100vh; position: relative; }
#cesiumContainer { width: 100%; height: 100%; }
.ui-toggle-btn { position: absolute; top: 10px; left: 10px; z-index: 200; font-size: 20px; cursor: pointer; user-select: none; background: rgba(10,12,20,0.8); border: 1px solid rgba(255,255,255,0.15); border-radius: 8px; width: 38px; height: 38px; display: flex; align-items: center; justify-content: center; transition: background .2s; }
.ui-toggle-btn:hover { background: rgba(255,215,0,0.15); }
.overlay-controls { position: absolute; top: 16px; left: 16px; z-index: 100; pointer-events: none; }
.ctrl-panel { pointer-events: auto; background: rgba(10,12,20,0.9); position: relative; transition: min-width .3s; border: 1px solid rgba(255,255,255,0.12); border-radius: 10px; padding: 16px 20px; color: #ccc; min-width: 210px; backdrop-filter: blur(10px); }
.panel-toggle { position: absolute; top: 8px; right: 10px; color: #FFD700; font-size: 14px; cursor: pointer; z-index: 5; user-select: none; width: 24px; text-align: center; }
.ctrl-panel.collapsed { min-width: auto; padding: 10px 12px; }
.ctrl-panel.collapsed .panel-toggle { position: static; }
.ctrl-title { font-size: 16px; font-weight: bold; color: #FFD700; margin-bottom: 10px; text-align: center; }
.toggle-row { display: flex; align-items: center; gap: 8px; margin-bottom: 8px; cursor: pointer; font-size: 13px; }
.toggle-row input { accent-color: #FFD700; }
.toggle-group { margin-bottom: 4px; }
.sub-toggles { padding-left: 12px; border-left: 1px solid rgba(255,255,255,0.1); margin-left: 4px; margin-top: 2px; }
.sub-row { font-size: 11px; margin-bottom: 3px; }
.sub-swatch { width: 10px; height: 10px; border-radius: 2px; display: inline-block; flex-shrink: 0; margin-right: 2px; }
.reset-btn { width: 100%; margin-top: 10px; padding: 8px; background: rgba(255,215,0,0.15); border: 1px solid rgba(255,215,0,0.3); color: #FFD700; border-radius: 6px; cursor: pointer; font-size: 13px; font-family: inherit; transition: background .2s; }
.reset-btn:hover { background: rgba(255,215,0,0.25); }
.overview-wrap { position: absolute; top: 16px; right: 16px; z-index: 100; display: flex; align-items: stretch; transition: transform .3s; }
.overview-wrap.collapsed { transform: translateX(190px); }
.overview-toggle { width: 22px; background: rgba(10,12,20,0.85); border: 1px solid rgba(255,215,0,0.3); border-right: none; border-radius: 6px 0 0 6px; color: #FFD700; font-size: 12px; display: flex; align-items: center; justify-content: center; cursor: pointer; user-select: none; }
.overview-toggle:hover { background: rgba(255,215,0,0.15); }
.overview-map { width: 220px; height: 220px; border: 2px solid rgba(255,215,0,0.4); border-radius: 0 10px 10px 0; overflow: hidden; position: relative; box-shadow: 0 0 20px rgba(0,0,0,0.6); }
.overview-iframe { width: 100%; height: 100%; border: none; display: block; }
.overview-label { position: absolute; top: 4px; left: 8px; font-size: 10px; color: rgba(255,215,0,0.7); pointer-events: none; font-weight: bold; }
.dem3d-overlay { position: absolute; bottom: 20px; left: 20px; z-index: 100; width: 400px; height: 340px; border: 2px solid rgba(255,215,0,0.4); border-radius: 12px; overflow: hidden; background: #0a0f16; box-shadow: 0 0 25px rgba(0,0,0,0.7); }
.dem3d-iframe { width: 100%; height: 100%; border: none; display: block; }
.legend-panel {
  position: absolute; bottom: 24px; right: 24px; z-index: 110;
  background: rgba(10,12,20,0.88); border: 1px solid rgba(255,255,255,0.15);
  border-radius: 10px; padding: 12px 16px;
  color: #ddd; max-height: 60vh; overflow-y: auto;
  backdrop-filter: blur(10px); min-width: 170px;
}
.legend-title { font-size: 13px; font-weight: bold; color: #FFD700; margin-bottom: 8px; text-align: center; }
.legend-list { display: flex; flex-direction: column; gap: 4px; }
.legend-item { display: flex; align-items: center; gap: 8px; font-size: 11px; }
.legend-swatch { width: 14px; height: 14px; border-radius: 3px; flex-shrink: 0; border: 1px solid rgba(255,255,255,0.2); }
.legend-name { white-space: nowrap; }
.weather-panel { position: absolute; top: 256px; right: 24px; z-index: 110; background: rgba(10,12,20,0.88); border: 1px solid rgba(255,255,255,0.15); border-radius: 10px; padding: 12px 16px; color: #ddd; max-height: 50vh; overflow-y: auto; backdrop-filter: blur(10px); min-width: 160px; }
.weather-title { font-size: 13px; font-weight: bold; color: #87CEEB; margin-bottom: 8px; text-align: center; }
.weather-loading { font-size: 11px; color: #aaa; text-align: center; }
.weather-row { display: flex; align-items: center; gap: 6px; padding: 4px 0; font-size: 12px; border-bottom: 1px solid rgba(255,255,255,0.06); }
.w-city { width: 36px; font-weight: bold; color: #ccc; }
.w-icon { width: 20px; text-align: center; }
.w-temp { width: 28px; color: #FF9800; font-weight: bold; }
.w-desc { color: #aaa; flex: 1; }
.w-humid { font-size: 10px; color: #5af; margin-left: auto; margin-right: 6px; }
.w-wind { font-size: 10px; color: #789; margin-left: auto; }
.weather-update { font-size: 9px; color: #555; text-align: right; margin-top: 6px; }
.legend-opacity { margin-top: 10px; padding-top: 8px; border-top: 1px solid rgba(255,255,255,0.12); display: flex; align-items: center; gap: 8px; font-size: 11px; }
.legend-opacity input[type=range] { flex: 1; accent-color: #FFD700; height: 4px; }
.opacity-label { color: #aaa; }
.opacity-val { color: #FFD700; min-width: 32px; text-align: right; }
.dem3d-label { position: absolute; top: 8px; left: 12px; font-size: 11px; color: rgba(255,215,0,0.8); pointer-events: none; font-weight: bold; text-shadow: 0 0 6px rgba(0,0,0,0.8); }
</style>


